import React from "react";
import DeleteDraft from "@components/FlowActionButtons/DeleteDraft";
import type { Task } from "@services/vesselCall/types";
import { canDiscardOrEditDraft } from "./utils";

interface DeleteCallDraftProps {
  vesselCallFlowData?: {
    vesselCallId: string;
    task: Task | null;
    status: string;
  };
  setIsConfirmDiscardDraftOpen: (isOpen: boolean) => void;
}

const LANG_BASE = "vessel-call.vessel-call-status-header";

const DeleteCallDraft: React.FC<DeleteCallDraftProps> = ({
  vesselCallFlowData,
  setIsConfirmDiscardDraftOpen,
}) => {
  if (!vesselCallFlowData) {
    return null;
  }
  const isActionAvailable = canDiscardOrEditDraft(vesselCallFlowData.status);
  const handleDeleteClick = () => {
    setIsConfirmDiscardDraftOpen(true);
  };

  return (
    <DeleteDraft
      langBase={LANG_BASE}
      permission="canHandleVesselCallDraft"
      isActionAvailable={isActionAvailable}
      onClick={handleDeleteClick}
    />
  );
};
export default DeleteCallDraft;
